import { IYeahState, YeahState } from './yeah.state';
import style from './yeah.module.scss';
import PreviewSectionYeah from './sections/preview-section';
import ProjectInfoSectionYeah from './sections/project-info-section';
import SolutionSectionYeah from './sections/solution-section';
import FeaturesSectionYeah from './sections/features-section';
import AccordionSectionYeah from './sections/accordion-section';
import ProductSectionYeah from './sections/product-section';
import FilterSectionYeah from './sections/filter-section';
import ShoppingBagSectionYeah from './sections/shopping-bag-section';
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import { Themes } from '@layouts/main-layout/themes.enum';

interface YeahProjectProps {
  breadcrumbsText: string;
}

const YeahComponent = ({ breadcrumbsText }: YeahProjectProps) => {
  const {
    PreviewSection,
    ProjectInfoSection,
    SolutionSection,
    FeaturesSection,
    AccordionSection,
    ProductSection,
    FilterSection,
    ShoppingBagSection,
  }: IYeahState = YeahState;
  return (
    <>
      <Breadcrumbs lastElementTitle={breadcrumbsText} theme={Themes.Dark} />
      <div className={`${style.yeah}`}>
        <PreviewSectionYeah
          title={PreviewSection.title}
          subtitle={PreviewSection.subtitle}
          imageSrc={PreviewSection.image}
          imageAlt={PreviewSection.alt}
          textArray={PreviewSection.text}
        />
        <hr />
        <ProjectInfoSectionYeah title={ProjectInfoSection.title} aboutProject={ProjectInfoSection.aboutProject} />
        <hr />
        <SolutionSectionYeah title={SolutionSection.title} textArray={SolutionSection.text} />
        <hr />
        <FeaturesSectionYeah title={FeaturesSection.title} textArray={FeaturesSection.text} />
        <hr />
        <AccordionSectionYeah title={AccordionSection.title} accordionItems={AccordionSection.accordionItems} />
        <hr />
        <ProductSectionYeah
          title={ProductSection.title}
          subtitle={ProductSection.subtitle}
          productItems={ProductSection.items}
          imageSrc={ProductSection.image}
          imageAlt={ProductSection.alt}
        />
        <hr />
        <FilterSectionYeah
          title={FilterSection.title}
          subtitle={FilterSection.subtitle}
          imageSrc={FilterSection.image}
          imageAlt={FilterSection.alt}
        />
        <hr />
        <ShoppingBagSectionYeah
          title={ShoppingBagSection.title}
          subtitle={ShoppingBagSection.subtitle}
          imageSrc={ShoppingBagSection.image}
          imageAlt={ShoppingBagSection.alt}
        />
      </div>
    </>
  );
};

export default YeahComponent;
